// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { fontConfig } from "@conklin/XDL/PreStyle/typography";
import wrapInContainerStyles from "@insite/client-framework/Common/wrapInContainerStyles";
import { pageTitleStyles } from "@insite/content-library/Widgets/ProductDetails/ProductDetailsPageTitle";
import { TypographyProps } from "@insite/mobius/Typography";
import { css } from "styled-components";

pageTitleStyles.titleText = {
    forwardAs: "h1",
    variant: "h2",
    css: css`
        @media print {
            font-size: 20px !important;
            line-height: 24px;
        }
    `,
};

export const nameText: TypographyProps = {
    color: "text.link",
    size: 14,
    lineHeight: "17px",
    weight: fontConfig.weight.bold,
    css: css`
        margin-bottom: 0;
        width: 100%;
        ${wrapInContainerStyles}
    `,
};

pageTitleStyles.brandStyles = {
    nameText: {
        ...nameText,
    },
    nameLink: {
        typographyProps: nameText,
        css: css`
            width: fit-content;
        `,
    },
};
pageTitleStyles.brandGridItem = {
    width: 12,
    css: css`
        padding-bottom: 4px;
    `,
};
